import { e as entry, a as _typeof, h as handleExternalUrl } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

var script = {
  mixins: [entry],
  data: function data() {
    return {
      showVolumeControl: false,
      entryNeedsVolumeControl: false
    };
  },
  computed: {
    playbackVolume: {
      get: function get() {
        return parseFloat(this.$xp.media.volume);
      },
      set: function set(v) {
        if (!Number.isNaN(v)) {
          this.$xp.media.setGlobalVolume(v);
          var volumeMessage = {
            method: 'volumeChanged',
            value: v
          };
          var iframes = document.getElementsByClassName('c-html-entry__iframe');
          var iframeElement = iframes.length > 0 ? iframes[0] : null;

          if (iframeElement) {
            iframeElement.contentWindow.postMessage(volumeMessage, '*');
          }
        } else {
          console.log('invalid volume: ' + v);
        }
      }
    }
  },
  mounted: function mounted() {
    console.log('htmlentry Mounted', this.entryData);
    window.addEventListener('message', this.onMessage, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.onMessage, false);
  },
  methods: {
    onMessage: function onMessage(e) {
      var method = '';

      if (typeof e.data === 'string') {
        method = e.data;
      } else if (_typeof(e.data) === 'object') {
        method = e.data.method;
      } else {
        throw Error('event data must be a string or an object contains method property as string');
      }

      console.log('HtmlEntry.onMessage:', e.data, ', method', method);

      switch (method) {
        case 'touchstart':
        case 'pointerdown':
          this.onTouchStart();
          break;

        case 'touchend':
        case 'pointerup':
          this.onTouchEnd();
          break;

        case 'back':
          this.$xp.history.back();
          break;

        case 'showPage':
          this.$router.push('/page/' + e.data.pageID);
          break;

        case 'goToNextPage':
          this.$router.push('/page/' + this.$xp.content.pageData.NextPageID);
          break;

        case 'openLink':
          handleExternalUrl(e.data.href);
          break;

        case 'showVolumeControl':
          this.sendMediaVolumeMessage();
          this.entryNeedsVolumeControl = true;
          break;

        case 'hideVolumeControl':
          this.entryNeedsVolumeControl = false;
          break;
      }
    },
    onTouchStart: function onTouchStart() {
      var e = new Event('pointerdown', {
        bubbles: true
      });
      this.$el.dispatchEvent(e);
    },
    onTouchEnd: function onTouchEnd() {
      var e = new Event('pointerup', {
        bubbles: true
      });
      this.$el.dispatchEvent(e);
    },
    sendMediaVolumeMessage: function sendMediaVolumeMessage() {
      var volumeMessage = {
        method: 'volumeChanged',
        value: this.$xp.media.volume
      };
      var iframes = document.getElementsByClassName('c-html-entry__iframe');
      var iframeElement = iframes.length > 0 ? iframes[0] : null;

      if (iframeElement) {
        iframeElement.contentWindow.postMessage(volumeMessage, '*');
      }
    }
  },
  watch: {
    '$xp.navigation.isNavHidden': function $xpNavigationIsNavHidden(value) {
      if (value === true) {
        this.showVolumeControl = false;
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "js-entry o-entry c-html-entry" }, [
    _vm.entryData.Content.Index
      ? _c("iframe", {
          staticClass: "c-html-entry__iframe",
          attrs: {
            src:
              _vm.$xp.settings.baseUrl + "xpedeo/" + _vm.entryData.Content.Index
          }
        })
      : _vm.entryData.Content.Url
      ? _c("iframe", {
          staticClass: "c-html-entry__iframe",
          attrs: {
            src:
              _vm.entryData.Content.Url.indexOf("http://") === 0 ||
              _vm.entryData.Content.Url.indexOf("https://") === 0
                ? _vm.entryData.Content.Url
                : _vm.$xp.settings.baseUrl + "pda/" + _vm.entryData.Content.Url
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.entryNeedsVolumeControl
      ? _c(
          "div",
          {
            class: {
              "c-html-player__controls": true,
              "is-hidden": _vm.$xp.navigation.isNavHidden,
              landscape: this.$xp.screen.orientation === "landscape-primary"
            }
          },
          [
            _c("div", { class: { "c-html-player__volume-wrapper": true } }, [
               _c(
                    "button",
                    {
                      staticClass: "c-html-player__volume-button",
                      attrs: {
                        tabindex: "0",
                        "aria-label": _vm.$t("global.setVolume")
                      },
                      on: {
                        click: function($event) {
                          _vm.showVolumeControl = !_vm.showVolumeControl;
                        }
                      }
                    },
                    [
                      _vm.$xp.media.volume >= 0.5
                        ? _c("span", {
                            staticClass: "xp xp-volume-up xp--large",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$xp.media.volume < 0.5 && _vm.$xp.media.volume !== 0
                        ? _c("span", {
                            staticClass: "xp xp-volume-down xp--large",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$xp.media.volume === 0
                        ? _c("span", {
                            staticClass: "xp xp-volume-off xp--large",
                            attrs: { "aria-hidden": "true", name: "volume-off" }
                          })
                        : _vm._e()
                    ]
                  )
                ,
              _vm._v(" "),
              _vm.showVolumeControl
                ? _c(
                    "div",
                    { staticClass: "c-html-player__volume-slider" },
                    [
                      _c("slider", {
                        attrs: {
                          value: _vm.playbackVolume,
                          orientation:
                            _vm.$xp.screen &&
                            _vm.$xp.screen.orientation === "landscape-primary"
                              ? "horizontal"
                              : "vertical",
                          trackSize: 10
                        },
                        on: {
                          "update:value": function($event) {
                            _vm.playbackVolume = $event;
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=HtmlEntry.js.map
